module.exports = __webpack_public_path__ + "static/img/mzsm_e_font.37409567.svg";